import { useState } from "react";
import { jumpToState } from "../../actions/studensts";

import AlertDenger from "../../components/AlertDenger";
import AlertSuccess from "../../components/AlertSuccess";
import Loading from "../../components/Loading";
import { validateReceiver, normalizeNationalId } from "../../components/MoheReceiverModal";
import AramexShippingFields, {
  EMPTY_SHIPPING,
  validateShipping,
  shippingPayload,
} from "../../components/AramexShippingFields";

const baseStateList = [
  "auditing",
  "auditing_pending",
  "invoice",
  "invoice_wait",
  "another_invoice",
  "request_edit",
  "score_validation",
  "score_request",
  "score_pending",
  "print",
  "print_validation",
  "moe_validation",
  "moe",
  "moe_pending",
  "deliver_onsite",
  "aramex",
  "mohe_validation",
  "mohe",
  "done",
];

const aatcReviewUsers = ["asmaa", "alaa", "abdelrhman"];
const aatcReviewStates = ["aatc_review", "moe_hold", "delivery_hold"];

export default function JumpToModal({ selected, setShow }) {
  const username = JSON.parse(localStorage.getItem("profile"))?.value[0]
    .username;

  let stateList;
  if (aatcReviewUsers.includes(username)) {
    const insertAt = baseStateList.indexOf("moe_pending") + 1;
    stateList = [
      ...baseStateList.slice(0, insertAt),
      ...aatcReviewStates,
      ...baseStateList.slice(insertAt),
    ];
  } else {
    // Other users can only jump up to and including request_edit
    stateList = baseStateList.slice(
      0,
      baseStateList.indexOf("request_edit") + 1,
    );
  }

  const [showSuccessAlert, setShowSuccessAlert] = useState(false);
  const [showDengerAlert, setShowDengerAlert] = useState(false);
  const [text, setText] = useState("");
  const [loading, setLoading] = useState(false);
  const [state, setState] = useState(stateList[0]);
  const [receiverName, setReceiverName] = useState("");
  const [receiverNationalId, setReceiverNationalId] = useState("");
  const [receiverPhone, setReceiverPhone] = useState("");
  const [receiverError, setReceiverError] = useState("");

  const needsReceiver = state === "mohe_validation";
  // Moving to Aramex: optional shipping fees (the server refuses them if the
  // invoice already has a shipping fee).
  const toAramex = state === "aramex";
  const [shipping, setShipping] = useState(EMPTY_SHIPPING);
  const [shippingError, setShippingError] = useState("");

  const handleClick = async () => {
    let receiver;
    if (toAramex) {
      const message = validateShipping(shipping);
      if (message) {
        setShippingError(message);
        return;
      }
      setShippingError("");
      receiver = shippingPayload(shipping);
    }
    if (needsReceiver) {
      const message = validateReceiver(receiverName, receiverNationalId, receiverPhone);
      if (message) {
        setReceiverError(message);
        return;
      }
      setReceiverError("");
      receiver = {
        receiver_name: receiverName.trim(),
        receiver_national_id: normalizeNationalId(receiverNationalId),
        receiver_phone: receiverPhone.replace(/[\s-]/g, ""),
      };
    }

    setLoading(true);
    const res = await jumpToState(selected, state, username, receiver);

    if (res?.status === 200) {
      setShowSuccessAlert(true);
      setText(res.data.message);
    } else {
      setShowDengerAlert(true);
      setText(res?.data?.ERROR || "Failed to change state");
    }
  };

  const onChange = async (e) => {
    setState(e.target.value);
  };

  if (showSuccessAlert || showDengerAlert) {
    setTimeout(function () {
      setShowSuccessAlert(false);
      setShowDengerAlert(false);
      setLoading(false);
      setShow(false);
    }, 1000);
  }

  return (
    <div
      className="flex overflow-y-auto overflow-x-hidden fixed right-0 left-0 
    top-4 z-40 justify-center items-center md:inset-0 h-modal sm:h-full"
    >
      {showSuccessAlert && <AlertSuccess text={text} />}
      {showDengerAlert && <AlertDenger text={text} />}
      <div className="relative px-4 w-full max-w-md h-full md:h-auto">
        <div className="relative bg-white rounded-lg shadow border">
          <div className="flex justify-end p-2">
            <button
              type="button"
              className="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center dark:hover:bg-gray-800 dark:hover:text-white"
              onClick={() => setShow(false)}
            >
              <svg
                className="w-5 h-5"
                fill="currentColor"
                viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                  clipRule="evenodd"
                ></path>
              </svg>
            </button>
          </div>
          <div className="p-6 pt-0 text-center">
            <h3 className="mb-5 text-lg font-normal text-gray-500 dark:text-gray-400">
              Select State To Jump.
            </h3>
            <div className="m-2 flex items-center justify-evenly">
              <label htmlFor="act_subject2">State:</label>
              <select
                className="p-2 ml-1 border rounded-xl focus:outline-blue-700"
                onChange={onChange}
                name="state"
                value={state}
              >
                {stateList.map((s, i) => (
                  <option value={s} key={i}>
                    {s}
                  </option>
                ))}
              </select>
            </div>
            {toAramex && (
              <div className="m-2 text-left">
                {shippingError && (
                  <p className="text-red-600 text-sm mb-2">{shippingError}</p>
                )}
                <p className="text-xs text-gray-500 mb-2">
                  Only if the student's invoice has no shipping fee.
                </p>
                <AramexShippingFields value={shipping} onChange={setShipping} idPrefix="jumpto" />
              </div>
            )}
            {needsReceiver && (
              <div className="m-2 text-left">
                {receiverError && (
                  <p className="text-red-600 text-sm mb-2">{receiverError}</p>
                )}
                <label className="block text-sm font-semibold mb-1">
                  Receiver Full Name <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  maxLength={255}
                  className="p-2 mb-3 w-full border rounded-xl focus:outline-blue-700"
                  value={receiverName}
                  onChange={(e) => setReceiverName(e.target.value)}
                />
                <label className="block text-sm font-semibold mb-1">
                  Receiver National ID <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  maxLength={20}
                  placeholder="National ID or passport number"
                  className="p-2 mb-3 w-full border rounded-xl focus:outline-blue-700"
                  value={receiverNationalId}
                  onChange={(e) => setReceiverNationalId(e.target.value)}
                />
                <label className="block text-sm font-semibold mb-1">
                  Receiver Phone Number <span className="text-red-500">*</span>
                </label>
                <input
                  type="tel"
                  maxLength={20}
                  placeholder="e.g. 01012345678"
                  className="p-2 mb-3 w-full border rounded-xl focus:outline-blue-700"
                  value={receiverPhone}
                  onChange={(e) => setReceiverPhone(e.target.value)}
                />
              </div>
            )}
            <button
              type="button"
              className="text-white bg-red-600 hover:bg-red-800 focus:ring-4
    focus:ring-red-300 font-medium rounded-lg text-sm inline-flex items-center px-5 py-2.5 text-center mr-2"
              onClick={handleClick}
              disabled={loading}
            >
              {!loading ? "Yes, I'm sure" : <Loading />}
            </button>
            <button
              type="button"
              className="text-gray-500 bg-white hover:bg-gray-100 focus:ring-4 
    focus:ring-gray-300 rounded-lg border border-gray-200 text-sm font-medium px-5 py-2.5 hover:text-gray-900 focus:z-10 "
              onClick={() => setShow(false)}
            >
              No, cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
